import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FadeDivider } from '@onesource/components';
import { FC } from 'react';
import { MdShield } from 'react-icons/md';

import { AccountPrivacyToggle } from './account-privacy-toggle';

// ----------------------------------------------------------------------

export const PRIVACY_MODE_DESCRIPTION =
  "When set to Private, you won't be visible in leaderboards, @mentions, or online presence features.";

/** Privacy Mode block on the Security and Privacy tab. */
export const AccountPrivacySection: FC = () => (
  <Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, color: 'primary.main' }}>
      <MdShield size={22} />
      <Typography variant="h6" fontWeight={700}>
        Privacy Mode
      </Typography>
    </Box>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
      {PRIVACY_MODE_DESCRIPTION}
    </Typography>

    <FadeDivider />

    <AccountPrivacyToggle />
  </Box>
);
